import { Component, OnInit } from '@angular/core';

import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-holidays',
  templateUrl: './holidays.component.html',
  styleUrls: ['./holidays.component.scss'],
})
export class HolidaysComponent implements OnInit {
  holidays: any;
  page: any = 1;
  total: any;
  count: any = 5;

  onBack() {
    this.location.back();
  }

  constructor(
    private route: Router,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private service: ApiService,
    private location: Location
  ) {}

  ngOnInit() {
    this.getHolidayList();
  }

  getHolidayList() {
    this.spinner.show();
    this.service.getRequest(ApiUrl.getHolidays).subscribe(
      (res: any) => {
        this.spinner.hide();
        // console.log(res, 'res');
        // Check if response is valid
        if (res && res.response && res.response.data) {
          this.holidays = res.response.data.nationalHolidayList;
          this.total = res.response.data.nationalHolidayCount;
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error('An error occurred while fetching store timings');
      }
    );
  }

  onAddHoliday() {
    this.route.navigate(['/addholidays']);
  }
  editAdmin(id: any) {
    this.route.navigate(['/editholiday/' + id]);
  }
  deleteAdmin(id: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.service.deletRequest(`${ApiUrl.deleteHoliday}${id}`).subscribe(
          (res: any) => {
            // console.log(res, "delete")
            this.toastr.success(res.response.message);
            this.getHolidayList();
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
          }
        );
      }
    });
  }
}
